(function () {
var $30f48e7c7d6109f3$var$error_logger = function(s) {
    "use strict";
    class d {
        subscribe(r) {
            return this._observers.add(r), this._messagesHistory.forEach((o)=>r(o)), {
                unsubscribe: ()=>this.unsubscribe(r)
            };
        }
        unsubscribe(r) {
            this._observers.delete(r);
        }
        notify(r) {
            this._messagesHistory.push(r), this._observers.forEach((o)=>o(r));
        }
        constructor(){
            this._observers = new Set, this._messagesHistory = [];
        }
    }
    function f(e, r) {
        return function(...o) {
            const t = Date.now();
            var _e_lastCall;
            if (!(t - ((_e_lastCall = e.lastCall) !== null && _e_lastCall !== void 0 ? _e_lastCall : 0) < r)) return e.lastCall = t, e(...o);
        };
    }
    function b() {
        var _document_querySelector;
        var _document_querySelector_getAttribute;
        return (_document_querySelector_getAttribute = (_document_querySelector = document.querySelector("head base")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getAttribute("href")) !== null && _document_querySelector_getAttribute !== void 0 ? _document_querySelector_getAttribute : "/";
    }
    async function w(e, r = "GET", o) {
        let { body: t, headers: n, ...c } = o !== null && o !== void 0 ? o : {};
        t !== null && typeof t == "object" && (t = JSON.stringify(t), n = {
            "Content-Type": "application/json",
            ...n
        });
        const a = await fetch(new URL(e, new URL(b(), window.location.href)), {
            method: r,
            body: t,
            headers: n,
            ...c
        });
        if (!a.ok) throw new Error(`Request failed with status code ${a.status}`);
        return a;
    }
    const h = {
        logException: ()=>Promise.resolve(!1)
    };
    async function u() {
        async function e(r, o = "Warning", t = "") {
            const n = new Date().toISOString(), c = typeof r == "string" ? r : JSON.stringify(r), a = {
                logLevel: o !== null && o !== void 0 ? o : "Warning",
                text: c,
                stack: t,
                timestamp: n,
                url: window.location.pathname,
                browserLanguage: window.navigator.language || window.navigator.userLanguage || "",
                userAgent: window.navigator.userAgent || "",
                browserVendor: window.navigator.vendor || ""
            };
            try {
                return await w("/Log/ClientError", "POST", {
                    body: a
                }), !0;
            } catch (E) {
                return console.error("Error logging exception", E), !1;
            }
        }
        return {
            logException: e
        };
    }
    const l = new d, i = f(function(...r) {
        l.notify(r);
    }, 100), m = 50;
    u().then((e)=>{
        const r = {
            count: 0
        };
        window.nepheleErrorLogger = e;
        const o = l.subscribe((t)=>{
            r.count++, e.logException(...t).catch(), r.count >= m && o.unsubscribe();
        });
    });
    const g = [
        "chrome-extension://",
        "moz-extension://"
    ];
    function y(e) {
        var _e_error;
        const r = (e === null || e === void 0 ? void 0 : e.filename) || "";
        if (g.some((t)=>r.startsWith(t))) return !0;
        const o = (e === null || e === void 0 ? void 0 : (_e_error = e.error) === null || _e_error === void 0 ? void 0 : _e_error.stack) || "";
        return !!g.some((t)=>o.startsWith(t));
    }
    return window.addEventListener("error", (e)=>{
        var _e_error;
        var _e_error_stack;
        y(e) || i(e.message, "Warning", (_e_error_stack = e === null || e === void 0 ? void 0 : (_e_error = e.error) === null || _e_error === void 0 ? void 0 : _e_error.stack) !== null && _e_error_stack !== void 0 ? _e_error_stack : "");
    }), window.addEventListener("unhandledrejection", (e)=>{
        i(e.reason);
    }), window.addEventListener("securitypolicyviolation", (e)=>{
        const r = {
            blockedURI: e.blockedURI,
            columnNumber: e.columnNumber,
            lineNumber: e.lineNumber,
            documentURI: e.documentURI,
            originalPolicy: e.originalPolicy,
            referrer: e.referrer,
            sourceFile: e.sourceFile,
            statusCode: e.statusCode,
            violatedDirective: e.violatedDirective
        };
        i(r, "Error");
    }), window.addEventListener("DOMException", (e)=>{
        const r = e, o = {
            message: r.message,
            name: r.name
        };
        i(o);
    }), s.NoopLogger = h, s.createLogger = u, s.logException = i, Object.defineProperty(s, Symbol.toStringTag, {
        value: "Module"
    }), s;
}({});



})();
//# sourceMappingURL=error-logger.js.map
